module.exports = __webpack_public_path__ + "static/media/solution-selection.d1bd5f95.png";